import React, { Component } from 'react';
import styled from 'styled-components';
import { ImgOverlayContainer } from '../../../theme/assets';
import { MainColumn } from '../../../theme/grid';
import { ButtonToggle, ButtonToggleContainer } from '../../../theme/buttons';

const BaseImage = styled.div`
    img {
      box-shadow: 0 2px 12px 0px #c4cad0;
    }
`;

class Redesign extends Component {
  constructor() {
    super();
    this.state = {
      mobileRedesignBefore: true,
      mobileRedesignText: false,
      mobileRedesignText2: true
    }
  }
  showMobileRedesignBefore(e){
    e.preventDefault();
    const { mobileRedesignBefore } = this.state;
    const { mobileRedesignText } = this.state;
    const { mobileRedesignText2 } = this.state;
    this.setState({
      mobileRedesignBefore: !mobileRedesignBefore,
      mobileRedesignText: !mobileRedesignText,
      mobileRedesignText2: !mobileRedesignText2
     })
  }

  render() {
    return (
      <div>
        <ButtonToggleContainer>
          <MainColumn>
            <ButtonToggle className={this.state.mobileRedesignText2} onClick={this.showMobileRedesignBefore.bind(this)} style={{'width': '120px'}}>Before</ButtonToggle>
            <ButtonToggle className={this.state.mobileRedesignText}  onClick={this.showMobileRedesignBefore.bind(this)} style={{'width': '120px'}}>After</ButtonToggle>
          </MainColumn>
        </ButtonToggleContainer>
          <ImgOverlayContainer>

            <BaseImage>
              <img alt="" style={{borderRadius: '4px'}} src={require('../../../assets/CallTools/Redesign/before@2x.png')} width="100%" />
            </BaseImage>

            {this.state.mobileRedesignBefore && <div>
              <img alt="" style={{borderRadius: '4px'}} src={require('../../../assets/CallTools/Redesign/script-after@2x.png')} width="100%" />
            </div> }

          </ImgOverlayContainer>
      </div>
    );
  }
}

export default Redesign;



// WEBPACK FOOTER //
// src/assets/CallTools/Redesign/Redesign.js